import { render, staticRenderFns } from "./profit_transfer_receive.vue?vue&type=template&id=578f08db&scoped=true"
import script from "./profit_transfer_receive.vue?vue&type=script&lang=js"
export * from "./profit_transfer_receive.vue?vue&type=script&lang=js"
import style0 from "./profit_transfer_receive.vue?vue&type=style&index=0&id=578f08db&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578f08db",
  null
  
)

export default component.exports